import React, { MouseEventHandler } from 'react';

import { RadioOrSelectOption } from '../../../../../types/common.types';
import { HashTag, Member } from '../../../../../types/entity.types';

import { POST_SEARCH_OPTIONS } from '../../../../../utils/constants';

import ProfilePicture from '../../../../common/profile-picture/ProfilePicture';
import TribeInfo from '../info/TribeInfo';

import TribeInputContainer from '../../../../../containers/programme/tribe/tribe-input/TribeInput.container';

import { ReactComponent as ArrowIcon } from '../../../../../resources/icons/arrow-single.svg';

import './tribe-message-compose.scss';

type Props = {
  profilePicture?: string;
  onBackClick: MouseEventHandler<HTMLButtonElement>;
  hashtags?: HashTag[];
  members: Member[];
  onPostSuccess: () => void;
  searchType?: RadioOrSelectOption;
  status: string;
  pendingApprovals: number;
};

const TribeMessageCompose = ({
  profilePicture,
  onBackClick,
  hashtags,
  members,
  onPostSuccess,
  searchType = POST_SEARCH_OPTIONS[0],
  status,
  pendingApprovals
}: Props) => (
  <div className="tribe__compose">
    <div className="tribe__header">
      <ArrowIcon className="tribe__header__arrow-icon" onClick={onBackClick} data-testid="arrow-icon" />
      <h1>Compose Message</h1>
    </div>
    <div className="tribe__compose__content">
      <div className="tribe__compose__content__left">
        <div className="tribe__compose__input-container">
          <ProfilePicture src={profilePicture} alt="member profile picture" medium />
          <TribeInputContainer
            placeholder="Compose..."
            hashtags={hashtags}
            onPostSuccess={onPostSuccess}
            searchType={searchType}
            focus
          />
        </div>
      </div>
      <div className="tribe__compose__content__right">
        <TribeInfo members={members} status={status} pendingApprovals={pendingApprovals} fullWidth />
      </div>
    </div>
  </div>
);

export default TribeMessageCompose;
